<template lang="pug">
  v-flex(:xs6="!mobile" :column="mobile" :style="{'padding': (!mobile) ? '15px 10px 15px 25px' : '20px 2%'}")
    v-card-title(style="position: relative")
      span.headline
        b {{$t('auth.admin')}}
    v-card-text(:class="{'py-0': !mobile}")
      v-form.pr-4
       v-flex(id="google-signin-button")
      v-layout.pl-1(justify-end)
    v-card-actions
      v-layout.pr-4(column :class="{'pl-2': mobile, 'pl-5': !mobile}")
</template>

<script>
import moment from 'moment'
import { global } from 'mixins/global'
import cryptoEvents from '@/events/cryptoEvents'
import cookie from 'js-cookie'

export default {
  mixins: [global],
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkbox: false,
      showSignUp: false,
      nowYear: moment().format('YYYY'),
      logo: require('@/assets/img/pic_achtaiwan_logo@2x.png'),
      background: require('@/assets/img/bg_login.png'),
      mobileBackground: require('@/assets/img/bg_login_m.png'),
      loading: false,
      googleSignIn: false,
      signInInfo: {
        email: '',
        brand: '',
        password: '',
        service: 'chuuka',
        authStatus: true
      }
    }
  },
  computed: {
    authStatus () {
      return this.$store.getters.authStatus
    },
    signInStatus(){
      return this.googleSignIn
    }
  },
  mounted () {
    gapi.load('auth2', function(){
      // Retrieve the singleton for the GoogleAuth library and set up the client.
      gapi.auth2.init({
        client_id: process.env.google_client_id || '210824251723-9vt2bl9jmso4bg536rpv7dl1opdi7ajm.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin'
        // Request scopes in addition to 'profile' and 'email'
        //scope: 'additional_scope'
      });
    });
    // 如果有輸入過訊息，切換到忘記密碼後返回登入頁時恢復上次輸入的訊息
    let info = this.$store.getters.recoverData
    if (info) {
      this.signInInfo.brand = info.brand
      this.signInInfo.email = info.email
    }
    // 格式為 service:timestamp，確保每一次產生後的編碼都不一樣
    // ex: fitness:1529884800
    if (this.$route.query && this.$route.query.service) {
      let serviceContent = Buffer.from(this.$route.query.service, 'base64').toString('ascii')
      this.signInInfo.service = (serviceContent.split(':')[0]) ? serviceContent.split(':')[0] : 'chuuka'
    }
 

   gapi.signin2.render("google-signin-button", {
        'onsuccess': this.onSuccess,
        'onfailure': this.onFailure
      }); 


    
  },
  methods: {
    onSuccess(googleUser) {
      cookie.set('GT', googleUser.getAuthResponse().id_token, {expires: 1}) // days
      this.googleSignIn = true
      this.nexPage()
    },
    nexPage(){
      if(this.signInStatus){
        this.$router.go('/adminLogin')
      }
    },
    btnEvent (event) {
      switch (event) {
        case 'login':
          this.signInInfo.authStatus = true
          this.$validator.validateAll()
            .then((result) => {
              if (result) {
                this.loading = true
                let params = {
                  username: this.signInInfo.email.toLowerCase(),
                  password: cryptoEvents.createHash(this.signInInfo.password),
                  grant_type: 'password',
                  tenant_id: this.signInInfo.service + '-' + this.signInInfo.brand
                }
                this.$store.dispatch('doLogin', {params: params})
                  .then(response => {
                    cookie.set('CT', response.data.cookie, {expires: 1}) // days
                    this.$store.commit('SET_AUTH_STATUS', '200')
                    this.signInInfo.authStatus = true
                    this.loading = false
                    if (response.data.firstLogin) {
                      this.$store.dispatch('fetchUserInfo')
                        .then(() => {
                          this.$emit('btnEvent', {action: event, firstLogin: response.data.firstLogin, password: params.password})
                        })
                    } else {
                      this.$emit('btnEvent', {action: event, firstLogin: response.data.firstLogin, password: params.password})
                    }
                  })
                  .catch(err => {
                    if (typeof err.response === 'undefined' || err.response.status !== 401) {
                      if (err.response && err.response.status === 400) {
                        // 合約內容 錯誤
                        this.$store.commit('SET_AUTH_STATUS', '401-003')
                      } else {
                        this.$store.dispatch('errorsHandler', {params: err})
                      }
                    } else {
                      this.$store.commit('SET_AUTH_STATUS', '401-001')
                    }
                    this.signInInfo.authStatus = false
                    this.loading = false
                  })
              }
            })
          break
        case 'forgetPw':
          this.$emit('btnEvent', {action: event})
          break
      }
    }
  },
  watch: {
    'signInInfo': {
      handler (value) {
        this.$store.commit('BACKUP_DATA', {
          brand: value.brand,
          email: value.email
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
